import { triggerLoad } from "unlazy";
import { createSpeculationRules } from "./scripts/speculation-rules";

createSpeculationRules({
  prerender: [
    {
      where: {
        and: [
          { href_matches: "/*" },
          { not: { href_matches: "/github" } },
          { not: { href_matches: "/linkedin" } },
          { not: { href_matches: "/x" } },
          { not: { href_matches: "/api/*" } },
          { not: { href_matches: "/card" } },
        ],
      },
      eagerness: "moderate",
    },
  ],
});

const navBtn = document.getElementById("nav_button") as HTMLButtonElement | null;
const navDialog = document.getElementById("nav_dialog") as HTMLDialogElement | null;
const navDialogCloseBtn = document.getElementById("nav_dialog_close") as HTMLButtonElement | null;

function openNavDialog() {
  navDialog?.showModal();
}

navBtn?.addEventListener("click", openNavDialog);

function closeNavDialog() {
  navDialog?.close();
}

navDialogCloseBtn?.addEventListener("click", closeNavDialog);

function observeImages() {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const image = entry.target as HTMLImageElement;
        triggerLoad(image);
        observer.unobserve(image);
      }
    },
    { rootMargin: "200px" },
  );

  // Inline placeholders load eagerly; only their full-resolution sources wait.
  for (const image of document.querySelectorAll<HTMLImageElement>("img[data-src]")) {
    if (image.dataset.src) observer.observe(image);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", observeImages, { once: true });
} else {
  observeImages();
}
